export const DASHBOARD_ROUTES = {
    BOOKINGS_LIST: '/bookings/list',
    BOOKINGS_IN_PROGRESS: '/bookings/list?in-progress=1',
    BOOKINGS_PENDING: '/bookings/list?pending=1',
    REQUESTS_LIST: '/requests/list',
    REQUESTS_IN_PROGRESS: '/requests/list?in-progress=1',
};

export const DASHBOARD_CARD_STYLES = {
    acceptedBookings: {
        bgClass: 'bg-bookings-year',
        increaseClass: 'text-success',
    },
    income: {
        bgClass: 'bg-income-year',
        increaseClass: 'text-success',
    },
    cancelledBookings: {
        bgClass: 'bg-cancelled-year',
        increaseClass: 'text-danger',
    },
    reviews: {
        bgClass: 'bg-reviews-year',
        increaseClass: '',
    },
    inProgressBookings: {
        bgClass: 'bg-bookings-progress',
        increaseClass: '',
    },
    pendingBookings: {
        bgClass: 'bg-bookings-pending',
        increaseClass: '',
    },
    inProgressRequests: {
        bgClass: 'bg-requests-progress',
        increaseClass: '',
    },
};

export const DASHBOARD_CHART_TYPES = [
    { label: 'Sales', value: 'sales' },
    { label: 'Orders Qty', value: 'ordersQty' },
    { label: 'Income', value: 'income' },
];